<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<h2 class="h2"><a id="page_vii"></a><a id="frontmatter01"></a>ACKNOWLEDGMENTS</h2>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para">To my agent, Manie Barron, who continues to bring brilliance to projects; my editor, Monique Patterson, whose tireless dedication can be felt on every page; to the team at St. Martin’s Press, who are like family; to Eric Battle, for his wondrously creative renderings of the characters (his art is da bomb!); to Vince Natale and Michael Storrings, who continue to blow me away with their cover art and designs; to Chris Bonelli, a saint who keeps the Web site fresh; and, of course, the Rowdee Black Giants, who always inspire—<em>go, brothers</em>—and to Zulma Gonzalez, an angel whom I am blessed to know.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?cfb222f4